// extracted by mini-css-extract-plugin
export var content = "_oj-1";
export var noScroll = "_oj-3";
export var paper = "_oj-0";
export var scrollable = "_oj-2";